<template>
<footer class="page-footer font-small bg-light text-center" id="footer">      
    <div class="text-center p-4" style="background-color:   rgb(121, 110, 110,0.6);">
      © 2022 Created by:
      <a class="text-reset fw-bold">Dale de Kock</a>
    </div>
  </footer>

  
</template>

<script>
export default {

}
</script>

<style>

</style>